import React from "react";
import CSVTools from "./CSVTools";
import { ThListIcon } from "@sanity/icons";

export default {
  title: "Spreadsheet Wizard",
  name: "spreadsheet-wizard",
  icon: ThListIcon,
  component: CSVTools,
};
